
<div class="col-lg-12" *ngIf="summaryDetail?.previousClose && !isChart">
    <div class="col-lg-6">
        <div class="property-details-box margin-top-15">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Previous Close</label>
                        <h6 class="displayvalue">{{summaryDetail?.previousClose?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Open</label>
                        <h6 class="displayvalue">{{summaryDetail?.regularMarketOpen?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Bid</label>
                        <h6 class="displayvalue">{{summaryDetail?.bid?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Ask</label>
                        <h6 class="displayvalue">{{summaryDetail?.ask?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Day's Range </label>
                        <h6 class="displayvalue">{{summaryDetail?.dayLow?.fmt}} - {{summaryDetail?.dayHigh?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">52 Weeks Range</label>
                        <h6 class="displayvalue">{{summaryDetail?.fiftyTwoWeekHigh?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Volume </label>
                        <h6 class="displayvalue">{{summaryDetail?.volume?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">AVG. Volume</label>
                        <h6 class="displayvalue">{{summaryDetail?.averageVolume?.fmt}}</h6>
                    </div>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Market Cap</label>
                        <h6 class="displayvalue">{{summaryDetail?.marketCap?.fmt}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Beta(5Y Monthly) </label>
                        <h6 class="displayvalue">{{summaryDetail?.beta?.fmt}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">PE Ratio</label>
                        <h6 class="displayvalue">{{summaryDetail?.payoutRatio?.fmt}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">EPS(TTM)</label>
                        <h6 class="displayvalue">{{calendarEvents?.earnings?.earningsAverage?.fmt}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Earnings Date</label>
                        <h6 class="displayvalue">{{calendarEvents?.earnings?.earningsDate[0]?.fmt | date:'MM/dd/yyyy'}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Forward Divident & Yield</label>
                        <h6 class="displayvalue">{{summaryDetail?.dividendYield?.fmt ? summaryDetail?.dividendYield?.fmt : ' - '}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">Ex-Dividend Date</label>
                        <h6 class="displayvalue">{{summaryDetail?.exDividendDate?.fmt ? (summaryDetail?.exDividendDate?.fmt | date:'MM/dd/yyyy') : ' - '}}</h6>
                    </div>
                </div>

                <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <div class="form-group">
                        <label class="blocklabel">1 Year Target EST</label>
                        <h6 class="displayvalue">{{summaryDetail?.riceToSalesTrailing12Months?.fmt ? summaryDetail?.riceToSalesTrailing12Months?.fmt : ' - '}}</h6>
                    </div>
                </div>
            </div>
            
            
        </div>
    </div>
    <div class="col-lg-6">
        <div id="chart1" class="chart-area">
            <div class="aspect-ratio"></div>
            <div class="chart-wrapper">
                <div id="chart"></div>
            </div>
        </div>
    </div>
</div>
<div class="col-lg-12" *ngIf="isChart">
    <div class="col-lg-12">
        <div id="chart1" class="chart-area">
            <div class="aspect-ratio"></div>
            <div class="chart-wrapper">
                <div id="chartLarge" style="min-height:700px !important"></div>
            </div>
        </div>
    </div>
</div>
